export default "__VITE_ASSET__zenjDKWv__"